<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"   
        v-on="on"
      >
        Create Transactions
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Detail"
      text="Create Transactions"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="7">
              <v-card class="pa-4 elevation-5">
                <v-text-field
                  v-model="searchInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />

                <v-autocomplete
                  v-model="filters.companies"
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Companies"
                  placeholder="Filter employee by company"
                  clearable
                  hide-selected
                  multiple
                  deletable-chips
                  chips
                />  
                <v-autocomplete
                  v-model="filters.jobCategories"
                  :items="jobCategories"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Job Category"
                  placeholder="Filter employee by job category"
                  clearable
                  hide-selected
                  multiple
                  deletable-chips
                  chips
                />
                
                <v-autocomplete
                  v-model="filters.positions"
                  :items="positions"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Position"
                  placeholder="Filter employee by position"
                  clearable
                  hide-selected
                  multiple
                  deletable-chips
                  chips
                />
     
                <v-data-table
                  v-model="selectedEmployees"
                  v-validate="'required'"
                  dense
                  :loading="tableLoading"
                  :headers="headers"
                  :items="filteredEmployees"
                  item-key="company_employee_uid"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-value="company_employee_uid"
                  show-select
                  class="elevation-1 mb-3"
                  height="272px"
                  :error-messages="errors.collect('selectedEmployees')"
                  data-vv-name="selectedEmployees"
                  data-vv-as="employee selection"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Employee Selection:</v-toolbar-title>
                    </v-toolbar>
                  </template>
                </v-data-table>
                <div :class="errors.first('selectedEmployees') ? 'py-0' : 'py-3'">
                  <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
                </div>
              </v-card>
            </v-col>
            
            <v-col cols="5">
              <v-row class="py-0">
                <v-col cols="6">
                  <v-menu
                    v-model="transactionDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="transactionDateDisplay"
                        v-validate="'required'"
                        label="Transaction Date"
                        :error-messages="errors.collect('transactionDateDisplay')"
                        data-vv-name="transactionDateDisplay"  
                        data-vv-as="transaction date"    
                        readonly
                        outlined
                        class="label-position"
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="transactionDate"
                      @input="transactionDateMenu = false"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="referenceCode"
                    v-validate="'required'" 
                    label="Reference Code"
                    :error-messages="errors.collect('referenceCode')"
                    data-vv-name="referenceCode"    
                    data-vv-as="reference code" 
                    outlined
                  />
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="deductionOrEarning"
                    v-validate="'required'"
                    :items="deductionOrEarnings"
                    item-text="name"
                    item-value="id"
                    label="DOE"
                    :error-messages="errors.collect('deductionOrEarning')"
                    data-vv-as="deduction or earning" 
                    data-vv-name="deductionOrEarning" 
                    hide-selected
                    outlined
                    multiple
                    return-object
                    @change="addDoe()"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <div class="font-weight-bold">
                          {{ data.item.name }}
                        </div>
                        <div>Cutoff Range</div>
                        <div style="text-transform:capitalize">
                          {{ data.item.cutoff_type.start_period.replace('_',' ') }} - {{ data.item.cutoff_type.start_day }} 
                        </div>
                        <div style="text-transform:capitalize">
                          {{ data.item.cutoff_type.end_period.replace('_',' ') }} - {{ data.item.cutoff_type.end_day }} 
                        </div>
                      </v-list-item-content>
                    </template>

                    <template v-slot:selection="data">
                      <v-chip
                        :input-value="data.selected"
                        close
                        class="chip--select-multi"
                        @click:close="removeDoe(data.item)"
                      >
                        {{ data.item.name }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-card
                v-for="(doe, index) in does"
                :key="index"
                class="px-3 pt-3 my-2 elevation-5"
              >
                <v-text-field
                  :key="index"
                  v-model="does[index].amount"
                  v-validate="'required|twoDecimalValue'"
                  :data-vv-name="'amount' + index"
                  :label="does[index].name+ ' Amount'"
                  prefix="RM"
                  :error-messages="errors.collect('amount' + index)"
                  data-vv-as="amount"
                  type="number"
                />
              </v-card>
 
              <v-card-actions style="position: absolute;bottom: 30px;right: 0px;">
                <v-spacer />
                <v-btn
                  :disabled="progressing"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  :loading="progressing"
                  color="hrissecondary"
                  class="white--text px-10"
                  @click="submitForm"
                >
                  Create
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollCycleTransaction: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        companies: [],
        positions: [],
        employees: [],
        jobCategories: [],
        tableLoading: false,
        searchInput: '',
        filters: {
          positions: '',
          jobCategories: '',
          companies: '',
        },
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'employee.person.name',
          },
          {
            text: 'Company',
            align: 'left',
            sortable: true,
            value: 'company.name',
          }, 
          {
            text: 'Job Category',
            align: 'left',
            sortable: true,
            value: 'employee.current_position.position.job_grade.job_category.name',
          },
          {
            text: 'Position',
            align: 'left',
            sortable: true,
            value: 'employee.current_position.position.name',
          },
        ],
        selectedEmployees: [],
        deductionOrEarnings: [],
        deductionOrEarning: null,
        amount: 0,
        transactionDateMenu: false,
        transactionDate: this.$moment().format('YYYY-MM-DD'),
        referenceCode: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        does: [],
      }
    },

    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee.employee.person || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })
        let filteredPositions = this.customFilterPositions(primaryFilterEmployees)
        let filteredJobCategories = this.customFilterJobCategories(filteredPositions)
        let filteredCompanies = this.customFilterCompanies(filteredJobCategories)
        
        return filteredCompanies
      },

      transactionDateDisplay () {
        return this.transactionDate ? this.$moment(this.transactionDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.tableLoading = true

        Promise.all([
          this.$api.payrollCycleTransactionCompanies().show(this.payrollCycleTransaction.id),
          this.$api.positions().list(),
          this.$api.payrollCycleEmployees().show(this.payrollCycleTransaction.id),
          this.$api.jobCategories().list(),
          this.$api.deductionOrEarnings().list('?filter[doe_category_id]=' + this.payrollCycleTransaction.payroll_cycle_id),
        ]).then(([company, position, employee, jobCategory, doe]) => {
          this.jobCategories = _.orderBy(jobCategory.data, ['name'], ['asc'])
          this.employees = _.orderBy(employee.data, ['employee.person.name', 'company.name'], ['asc', 'asc'])
          this.positions = _.orderBy(position.data, ['name'], ['asc'])
          this.companies = _.orderBy(company.data, ['name'], ['asc'])
          this.deductionOrEarnings = _.orderBy(doe.data, ['name'], ['asc'])

          this.tableLoading = false
        })

        let scope = this

        this.$validator.extend('twoDecimalValue', {
          getMessage (field, args) {
            return 'Only 2 Decimals are allowed'
          },
          validate (value, args) {
            return scope.isValidDecimalNumbers(value)
          },
        })
      },
    },
    
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.payrollCycleTransactions().createMany(this.payrollCycleTransaction.id, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })

                this.setProgressing(false)
                this.dialog = false
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.setProgressing(false)
              })
          })
      },
      prepareFormData () {
        return {
          employees: this.selectedEmployees,
          transaction_date: this.transactionDate,
          referenceCode: this.referenceCode,
          does: this.does,
        }
      },
      customFilterPositions (transactions) {
        if (this.filters.positions.length === 0) return transactions

        return transactions.filter(transaction => {
          let positionId = (transaction.employee.current_position || {}).position_id

          return _.intersection([positionId], this.filters.positions).length > 0
        })
      },
      customFilterJobCategories (transactions) {
        if (this.filters.jobCategories.length === 0) return transactions

        return transactions.filter(transaction => {
          let jobCategoryId = ((((transaction.employee.current_position || {}).position || {}).job_grade).job_category || {}).id

          return _.intersection([jobCategoryId], this.filters.jobCategories).length > 0
        })
      },
      customFilterCompanies (transactions) {
        if (this.filters.companies.length === 0) return transactions

        return transactions.filter(transaction => {
          let companyUid = transaction.company_uid

          return _.intersection([companyUid], this.filters.companies).length > 0
        })
      },
      setProgressing (status) {
        this.progressing = status
      },
      addDoe () {
        this.does.push({
          id: this.deductionOrEarning[this.deductionOrEarning.length - 1].id,
          name: this.deductionOrEarning[this.deductionOrEarning.length - 1].name,
          amount: 0,
        })
      },

      removeDoe (item) {
        let index = this.deductionOrEarning.findIndex(selectedId => selectedId.id === item.id)

        if (index >= 0) {
          this.deductionOrEarning.splice(index, 1)
          this.does.splice(index, 1)
        }
      },

      isValidDecimalNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
